import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const SolidBlendIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 68,
  height = 34,
  ...rest
}) => {
  return (
    <Icon
      data-testid="needs-based-filter-icon-solidBlend"
      fill={fill}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      width={width}
      {...rest}
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M42.0416305,0.000866926908 C42.5540218,0.0222165622 42.9602556,0.425518121 42.9972662,0.924830442 L42.9991331,1.04163054 L41.959201,26 L22.040799,26 L21.0008669,1.04163054 C20.977875,0.489824585 21.4065635,0.0238588419 21.9583695,0.000866926908 C22.4707607,-0.0204827084 22.9091367,0.347626776 22.9875562,0.842129511 L22.9991331,0.958369455 L23.959,24 L40.04,24 L41.0008669,0.958369455 C41.0222166,0.445978207 41.4255181,0.0397443743 41.9248304,0.00273382481 L42.0416305,0.000866926908 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M41.8827822,24 L22.1172178,24 L20.8672178,34 L43.1327822,34 L41.8827822,24 Z M40.116,26 L40.866,32 L23.133,32 L23.883,26 L40.116,26 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M33.5,29 C33.5,29.828 32.828,30.5 32,30.5 C31.172,30.5 30.5,29.828 30.5,29 C30.5,28.172 31.172,27.5 32,27.5 C32.828,27.5 33.5,28.172 33.5,29"
          fill="#ffffff"
          className={styles.white}
        />
        <path
          d="M32,27 C30.8958576,27 30,27.8958576 30,29 C30,30.1041424 30.8958576,31 32,31 C33.1041424,31 34,30.1041424 34,29 C34,27.8958576 33.1041424,27 32,27 Z M32,28 C32.5518576,28 33,28.4481424 33,29 C33,29.5518576 32.5518576,30 32,30 C31.4481424,30 31,29.5518576 31,29 C31,28.4481424 31.4481424,28 32,28 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="36 21 39 21 39 18 36 18"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="25 17 28 17 28 14 25 14"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="35 16 38 16 38 13 35 13"
        />
        <polygon fill="#0050B3" className={styles.interactiveColor} points="30 9 33 9 33 6 30 6" />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="34.621 18.5 32.5 20.621 30.378 18.5 32.5 16.379"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="33.621 12.5 31.5 14.621 29.378 12.5 31.5 10.379"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="28.621 10.5 26.5 12.621 24.378 10.5 26.5 8.379"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="39.621 9.5 37.5 11.621 35.378 9.5 37.5 7.379"
        />
        <polygon
          fill="#0050B3"
          className={styles.interactiveColor}
          points="29.621 20.5 27.5 22.621 25.378 20.5 27.5 18.379"
        />
        <path
          d="M45,6 C45.5522847,6 46,6.44771525 46,7 C46,7.51283584 45.6139598,7.93550716 45.1166211,7.99327227 L45,8 L42,8 C41.4477153,8 41,7.55228475 41,7 C41,6.48716416 41.3860402,6.06449284 41.8833789,6.00672773 L42,6 L45,6 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
        <path
          d="M46,4 C46.5128358,4 46.9355072,4.38604019 46.9932723,4.88337887 L47,5 L47,15 C47,15.5522847 46.5522847,16 46,16 C45.4871642,16 45.0644928,15.6139598 45.0067277,15.1166211 L45,15 L45,5 C45,4.44771525 45.4477153,4 46,4 Z"
          fill="#00000"
          className={styles.defaultColor}
          fillRule="nonzero"
        />
      </g>
    </Icon>
  )
}
